// Shared admin-only timestamp formatter. Converts a stored UTC/ISO timestamp
// to the viewer's browser-detected local timezone for display only; storage
// and backend logic are never touched here.
const ADMIN_DATETIME_FORMAT = new Intl.DateTimeFormat("en-US", {
  dateStyle: "medium",
  timeStyle: "short",
});

export function formatAdminDateTime(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return ADMIN_DATETIME_FORMAT.format(d);
  } catch {
    return iso;
  }
}
